// extracted by mini-css-extract-plugin
export default {"headerWrapper":"Header_headerWrapper__Y0JL0","headerContent":"Header_headerContent__prDjQ","logoWrapper":"Header_logoWrapper__xg59m","user":"Header_user__vOhFY"};